export interface HelpfulnessVotable {
  /** Which way this browser voted; null when it has not voted yet. */
  voted_helpful: boolean | null;
  helpful_count: number;
  not_helpful_count: number;
}

/**
 * Moves the local tallies to match a vote, mirroring what the backend does:
 * switching sides takes the vote off the other counter first, and voting the
 * same way twice changes nothing.
 *
 * Returns false when there is nothing to send to the backend.
 */
export const applyHelpfulnessVote = (
  item: HelpfulnessVotable,
  helpful: boolean,
): boolean => {
  if (item.voted_helpful === helpful) {
    return false;
  }

  if (item.voted_helpful !== null) {
    const previous =
      item.voted_helpful === true ? "helpful_count" : "not_helpful_count";
    item[previous] = Math.max(0, item[previous] - 1);
  }

  item[helpful === true ? "helpful_count" : "not_helpful_count"] += 1;
  item.voted_helpful = helpful;

  return true;
};
